<template>
  <div class="search">
    <!-- left-arrow -->
      <!-- @click-left="onClickLeft" -->
    <van-nav-bar
      >
      <template #title>
        <div class="search-cont">
          <form action="/">
            <van-search
              show-action
              v-model="form.enterpriseName"
              placeholder="搜索企业"
              @search="loadFirstPage"
              @cancel="onCancel">
              <template #action>
                <div @click="loadFirstPage">搜索</div>
              </template>
            </van-search>
          </form>
        </div>
      </template>
    </van-nav-bar>
    <div class="search-condition">
      <ul class="condition">
        <li @click="enterJob">搜职位</li>
        <li class="select">搜公司</li>
      </ul>
      <ul class="pop-select">
        <li @click="showPickerPlace">{{place}}</li>
        <li @click="showFilterPop">筛选</li>
      </ul>
    </div>
    <!--empty-->
    <van-empty
      v-if="companySimple.length==0"
      class="custom-image"
      :image="empty"
      description="暂未搜索到相关的公司"
    >
      <p>换个关键词试一试吧～</p>
    </van-empty>

    <van-list
      v-model="status.loading"
      :finished="status.finished"
      finished-text="没有更多了"
      @load="next()"
    >
    <ul class="company-list-simple">
      <li v-for="item in companySimple" :key="item.index" @click="companyDetail(item.id)">
        <img v-if="item.enterpriseLogoUrl" :src="item.enterpriseLogoUrl"/>
        <img v-else src="../../../../assets/img/ent_deft.png"/>
        <div class="detail-info">
          <h3>{{item.enterpriseName}}</h3>
          <ul class="feature">
            <li>{{ item.enterpriseTypeName }}</li>
            <li>{{ item.enterpriseTradesName }}</li>
            <li>{{ item.personnelSize }}</li>
          </ul>
          <div class="jobs">
            <div class="place">{{item.enterpriseAreaName}}</div>
            <div class="num">
              在招职位 <span>{{item.positionCnt}}</span> 个
            </div>
          </div>
        </div>
      </li>
    </ul>
    </van-list>

    <van-popup v-model="showPlace" round position="bottom">
      <van-picker
        show-toolbar
        value-key="title"
        :columns="areaLabelList"
        @cancel="closePlace"
        @confirm="onConfirm"
      />
    </van-popup>

    <!--智能筛选-->
    <transition name="fade">
      <div class="filter-cont" v-show="filterPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenPop"></van-icon>
          <h2>智能筛选</h2>
        </div>


        <h3>公司规模
          <small></small>
        </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in personnelSizeList" :key="index" :class="{checked:item.dictKey==form.personnelSize}"
              @click="selectPersonnelSize(item.dictKey)"><span>{{item.dictValue}}</span></li>
        </ul>
        <h3>公司性质
          <small></small>
        </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in entTypeList" :key="index" :class="{checked:item.dictKey==form.enterpriseType}"
              @click="selectEntType(item.dictKey)"><span>{{item.dictValue}}</span></li>
        </ul>
        <div class="fixed-bottom">
          <van-button type="primary" class="btn-gray" color="#EEEFF1" @click="clearEntSearch" round>清 除</van-button>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)"
                      @click="submitEntSearch" round>确 定
          </van-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'searchCompany',
    data() {
      return {
        form: {
          current:0,
          size:10,
          urgent: "",
          personnelSize: "",
          enterpriseTradesId: "",
          enterpriseAreaId: "",
          enterpriseType: "",
          enterpriseName: "",
        },

        status: {
          loading: false,
          finished: false
        },
        industrySelect: false,
        filterPop: false,

        //企业类型
        entTypeList: [],
        //企业规模
        personnelSizeList: [],
        showPlace: false,
        empty: require('@/assets/img/empty.png'),
        place: '地点',
        areaMap: {},
        areaLabelList: [],
        companySimple: []
      }
    },
    methods: {

      next(){
        this.form.current++;
        this.onload();
      },

      loadFirstPage(){
        this.form.current=1;
        this.companySimple=[];
        this.onload();
      },

      onClickLeft() {
        this.$router.go(-1)
      },
      onSearch() {
        this.$router.push({name: 'result'})
      },
      onCancel() {

      },
      closePlace() {
        this.showPlace = false
      },

      onConfirm(value) {
        this.place = value
        this.showPlace = false
        for (let o in this.areaMap) {
          if (o == value) {
            this.form.enterpriseAreaId = this.areaMap[o];
            break;
          }
        }
        this.loadFirstPage();

      },
      enterJob() {
        this.$router.push({name: 'searchJob'})
      },
      showPickerPlace() {
        this.showPlace = true
      },
      companyDetail(id) {
        this.$router.push({path: '/jiading/job/companyDetail', query: {id}})
      },

      selectPersonnelSize(value) {
        this.form.personnelSize = value
      },
      selectEntType(value) {
        this.form.enterpriseType = value
      },

      onload() {
        this.module.api.entList({
          params: this.form,
          success: (data) => {
            this.companySimple=this.companySimple.concat(data.records);

            if (this.companySimple.length>0){
              this.status.finished = this.form.current >= data.pages
            }

            this.status.loading = false
          }
        })
      },
      /**
       * 获取区域列表
       */
      loadArea(pid,grade) {
        this.module.api.area({
          params: {parentId: pid,grade},
          success: (records) => {
            let map = [];
            let labelList = [];
            for (let i = 0; i < records.length; i++) {
              map[records[i].title] = records[i].id
              labelList.push(records[i].title);
            }
            this.areaMap = map;
            this.areaLabelList = labelList;
          }
        })
      },
      /**
       * 清除智能筛选数据
       */
      clearEntSearch() {
        this.form.personnelSize = "";
        this.form.enterpriseType = "";
      },

      hiddenPop() {
        this.filterPop = false
      },
      showFilterPop() {
        this.filterPop = true
      },
      /**
       * 提交智能筛选
       */
      submitEntSearch() {
        this.filterPop = false;
        this.loadFirstPage();
      },

      /**
       * 加载公司性质
       */
      loadEntType() {
        this.module.api.bizDict({
          params: {code: "ent_info_type"},
          success: (records) => {
            this.entTypeList = records;
          }
        })
      },

      /**
       * 加载公司规模
       */
      loadPersonnelSize() {
        this.module.api.bizDict({
          params: {code: "personnel_size"},
          success: (records) => {
            this.personnelSizeList = records;
          }
        })
      },
    },

    mounted() {
      this.loadPersonnelSize();
      this.loadEntType();
      //嘉定区 id
      this.loadArea(0,2);
    }
  }
</script>

<style lang="less" scoped>
  .search-condition {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 16px 20px;

    ul {
      display: flex;
      align-items: center;

      li {
        color: #B7BABF;
        font-size: 12px;
        padding: 6px 12px;
      }

      &.condition {
        .select {
          background: #F5F2EF;
          color: #2E3133;
          border-radius: 50px;
        }
      }

      &.pop-select {
        li {
          position: relative;

          &:after {
            content: '\e629';
            position: absolute;
            right: -6px;
            top: 10px;
            font-family: van-icon;
          }
        }
      }
    }
  }

  .job-list {
    margin-left: 0;
    margin-right: 0;

    & > li {
      padding: 6px 16px;
      border-bottom: 8px solid #F7F7F7;

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .company-list-simple {
    margin-left: 0;
    margin-right: 0;

    & > li {
      border-bottom: 8px solid #F7F7F7;
      padding-bottom: 16px;
      padding-left: 16px;
      padding-right: 16px;
      align-items: flex-start;

      &:last-child {
        border-bottom: 0;
      }

      .detail-info {
        h3 {
          font-size: 16px;
          margin-bottom: 8px;
        }
      }

      .jobs {
        color: #3A3A3A;
        margin-left: -16px;
        font-size: 14px;

        &:after {
          content: '\e603';
          font-size: 10px;
          position: absolute;
          right: -10px;
          top: 50%;
          margin-top: -5px;
          font-family: van-icon;
          color: #C6CDD6;
        }

        .num {
          color: #606060
        }
      }
    }
  }
</style>
